import { connect } from 'react-redux'

import Success from './Success'
import * as fromEntities from '@src/redux/modules/entities'
import * as qs from 'utils/querystring'

const mapStateToProps = (state, ownProps) => {
  const aliadas = fromEntities.getAliadas(state)
  const aliadaId = ownProps.params.aliadaId

  const { bookingId, serviceTypeId, serviceDate, serviceTime } = qs.parse(ownProps.location.search)

  return {
    aliada: aliadas[aliadaId],
    bookingId,
    serviceTypeId,
    serviceDate,
    serviceTime
  }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Success)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Success/SuccessContainer.js